import { TagDto } from "generated/graphql";
import { defaultSerializer, SerializerOptions } from "../index";

export const TagDtoSerializer = {
  type: "TagDto",
  serializer: (entity: TagDto, options: SerializerOptions): Partial<TagDto> | null => {
    if (options?.parent?.__typename === "TagCategoryTagDto") {
      return defaultSerializer(entity, { level: 0 });
    }

    return defaultSerializer(entity, options);
  },
};
